import { render, staticRenderFns } from "./screen_gerencia.vue?vue&type=template&id=1320806c"
import script from "./screen_gerencia.vue?vue&type=script&lang=js"
export * from "./screen_gerencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports